import {
  validateFormat,
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

export default {
  title: [
    validatePresence(true),
    validateFormat({ type: 'string', allowBlank: false }),
  ],
  icon: [validatePresence(true), validateLength({ max: 3 })],
  url: [
    validatePresence(true),
    validateFormat({ type: 'url', allowBlank: false }),
  ],
};
